<style lang="sass" scoped>
.home-index
    min-width: 1000px
    position: relative
    height: 100%
.p-main
    min-width: 880px
    padding: 0
    height: calc(100% - 200px)
.put-status
    overflow: hidden
    min-width: 880px
    .put-status-box
        min-width: 200px
        width: calc(25% - 20px)
        height: 80px
        margin: 20px 10px
        float: left
        padding: 15px 20px
        border-radius: 10px
        background: #fff
        cursor: pointer
        &.color, &:hover
            background: linear-gradient(315deg,rgba(250,234,97,1) 0%,rgba(255,184,31,1) 100%)
            .num
                color: #421EEF
        img
            width: 50px
            float: left
            margin-right: 20px
        .fl
            .num
                font-size: 24px
                font-weight: 600
        .fr
            margin-top: 20px
</style>

<template lang="pug">
.home-index
  .p-title 首页
  //- .put-status(v-if="contentTypeList.length > 0")
  .put-status
    .put-status-box.color(@click="topBoxClick('待上传')")
      img(src="../assets/h-icon1.png")
      .fl
        .num {{topNum.will}}
        span 待上传
      i.el-icon-arrow-right.fr
    .put-status-box(@click="topBoxClick('审核中')")
      img(src="../assets/h-icon2.png")
      .fl
        .num {{topNum.ing}}
        span 审核中
      i.el-icon-arrow-right.fr
    .put-status-box(@click="topBoxClick('审核通过')")
      img(src="../assets/h-icon3.png")
      .fl
        .num {{topNum.done}}
        span 审核通过
      i.el-icon-arrow-right.fr
    .put-status-box(@click="topBoxClick('审核不通过')")
      img(src="../assets/h-icon4.png")
      .fl
        .num {{topNum.reject}}
        span 审核不通过
      i.el-icon-arrow-right.fr
  .p-main
    .home
      .home-fee
        .center
          .each
            span 总余额
            .els.Akrobat-ExtraBold
              span.small ￥
              span {{fee(allFee)}}
              span.small .{{fee(allFee, 1)}}
          .each
            span 现金余额
            .els.Akrobat-ExtraBold
              span.small ￥
              span {{fee(cashFee)}}
              span.small .{{fee(cashFee, 1)}}
          .each
            span 赠款余额
            .els.Akrobat-ExtraBold
              span.small ￥
              span {{fee(giveFee)}}
              span.small .{{fee(giveFee, 1)}}

        .fl.home-put
          .btn(@click="quickPut") 快速投放
            img(src="../assets/home-arrow1.png")

      .home-main
        div
          .gg-tab(
            v-for="(item, i) in chartTabs" :key="i"
            :class="{'cur': curEchartType == i}" @click="curEchartType = i"
          ) {{item}}

        .echart-main
          .not-see(v-if="noEchartData")
            div 暂无数据，快去投广告吧~
            span(@click="goUrl('/putOrderMap')" style="margin-top: 10px;color: #FF3973;cursor: pointer;") 点击投放广告>>

          template(v-else)
            .not-see(v-if="!isCanSee")
              div 哎呀，您不能查看此模块！
              span 消费金额到达10000元后即可开启此模块

            .switch-ctn(v-if="isCanSee")
              .tab(
                v-for="(item, i) in tabConfig" :key="i" @click="curSwitchIdx = i"
                :class="{'cur': curSwitchIdx === i}"
                v-if="!(hasTimeLimit && item === '分时')"
              ) {{item}}

            .pie-title(v-if="isCanSee") {{echartsTitle}}
              i(
                v-if="orderInfo && orderInfo.startDate"
                style="font-style: normal;font-size: 16px;color: #999;margin-left: 5px;font-weight: normal;"
              ) ({{orderInfo.startDate}} ~ {{orderInfo.endDate}})
              span(v-if="curSwitchIdx == 1")
                span.l 切换日期（
                el-datePicker(
                  v-model="pieDate" size="mini" value-format="yyyy-MM-dd" @change="getOrderGraphInfo"
                  :picker-options="datePickerOptions"
                )
                span.r ）>>

            div(style="height: calc(100% - 30px)")
              EchartOrderData(
                :data="echartPieData" :showDataTab="curEchartType" :timeType="curSwitchIdx"
                :curOrderInfo="orderInfo"
              )

</template>

<script>
import { mapState } from 'vuex'
import {
  getOrderContentCode,
  getReportOrderList,
  getOrderGraphDay,
  getOrderGraphSegment
} from '../utils/api'

export default {
  name: "home",
  components: {
    EchartBarLine: () => import("../components/EchartBarLine.vue"),
    EchartOrderData: () => import("../components/EchartOrderData.vue")
  },
  data() {
    let tday = new Date();
    let vm = this;
    let td =
      tday.getFullYear() + "." + (tday.getMonth() + 1) + "." + tday.getDate();
    return {
      tabConfig: ['分天'], // 2023-10-18 v4.28.0 在线图表隐藏'分时'入口
      nums: {},
      td: "",
      contentTypeList: [],
      topNum: {
        ing: 0,
        will: 0,
        done: 0,
        reject: 0
      },
      orderInfo: {},
      echartPieData: [],
      chartTabs: ['广告流量', '匹配率'],
      curEchartType: 0,
      curSwitchIdx: 0,
      echartsTitle: "",
      pieDate: "",
      datePickerOptions: {
        disabledDate(data) {
          if (!vm.orderInfo.startDate) return true;
          return (
            new Date(data).setHours(0, 0, 0) -
            new Date(vm.orderInfo.startDate).setHours(0, 0, 0) <
            0 ||
            new Date(data).setHours(0, 0, 0) -
            new Date(vm.orderInfo.endDate).setHours(0, 0, 0) >
            0
          );
        }
      },
      noEchartData: true,
      orderReport: {}
    };
  },
  watch: {
    curSwitchIdx(v) {
      if (v == 0) {
        this.pieDate = ""
      } else {
        if (this.orderInfo && this.orderInfo.startDate) this.pieDate = this.orderInfo.startDate
      }
      this.getOrderGraphInfo()
    }
  },
  computed: {
    ...mapState({
      adUser: s => {
        return s ? s.customer.userInfo : {};
      },
      customer: s => {
        return s ? s.customer.customerInfo : {};
      },
      balanceInfo: s => {
        return s ? s.customer.balanceInfo : {};
      }
    }),
    isAuth() {
      // 客户资料是否认证通过
      if (this.customer && this.customer.advertiserType)
        return this.customer.checkStatus === 1; // 审核通过(生效)
      return false;
    },
    hasTimeLimit() {
      return this.orderInfo.targetType == 3
    },
    oneStar() {
      return (
        !this.orderReport ||
        !this.orderReport.hasOwnProperty("targetFlowrateNum") ||
        this.orderReport.targetFlowrateNum === -1
      )
    },
    isCanSee() {
      // 是否可以查看图表
      return this.isAuth && (!this.oneStar || this.curEchartType == 1);
    },
    allFee() {
      return this.balanceInfo.balance || 0;
    },
    cashFee() {
      return this.balanceInfo.cash || 0;
    },
    giveFee() {
      return this.balanceInfo.give || 0;
    },
    fee() {
      return (money, type) => {
        if (!money) return type ? "00" : 0;
        let isMinus = money < 0;
        if (isMinus) money = 0 - money;
        if (!type) {
          let arr = (Math.floor(money) + "").split("").reverse();
          let a = [];
          arr.forEach((el, i) => {
            a.push(el);
            if ((i + 1) % 3 == 0) a.push(",");
          });
          let str = a.reverse().join("");
          let data = str.charAt(0) == "," ? str.slice(1) : str;
          return isMinus ? "-" + data : data;
        } else {
          let sp = (money + "").split(".");
          return sp.length > 1
            ? sp[1].length == 1
              ? sp[1] + "0"
              : sp[1].substr(0, 2)
            : "00";
        }
      };
    },
    typeV() {
      return str => {
        let idx = this.contentTypeList.map(el => el.dictItemName).indexOf(str);
        return idx < 0 ? "" : this.contentTypeList[idx].dictItemCode;
      }
    }
  },
  async created() {
    await this.contentType();
    this.$store.dispatch("customer/getAccBalance"); // 账户余额
    this.getTopNum(); // 广告素材审核状态分类数目

    this.initInfoOrder(); // 图表数据
  },
  methods: {
    topBoxClick(str) {
      tzx_czcPush("index", `orderStatusClick`, str);
      this.goUrl("/orderVideo", { type: this.typeV(str) });
    },
    async initInfoOrder() {
      const res = await this.fetch("/dsp/web/order/v2/getOrderContentUseCanSelect", {}, "get")
      if (res && res.code == this.successCode && res.data)
        this.handleListData(res.data)
      else this.noEchartData = true
    },
    handleListData(info) {
      if (info && info.orderCode) {
        this.noEchartData = false
        this.orderInfo = info
        this.echartsTitle = info.contentName
        this.getOrderGraphInfo()
      } else {
        this.noEchartData = true
      }
    },
    quickPut() {
      // 快速投放跳转到地图投放
      if (
        (this.adUser && !this.adUser.customerId) ||
        (this.customer && this.customer.checkStatus !== 1)
      ) {
        return this.messageTip("请完成资质认证后重试", 2);
      }
      tzx_czcPush("index", "gotoPutOrder");
      this.goUrl("/putOrderMap"); // goUrl 导航中的高亮会不更新
    },
    async getTopNum() {
      // 获取顶部素材数据
      const creaty = await this.$store.dispatch("orderSum", {
        orderStatusList: "3,4"
      });
      if (creaty) {
        this.topNum.will = creaty.exec0Count || 0;
        this.topNum.ing = creaty.exec1Count || 0;
        this.topNum.done = creaty.exec2Count || 0;
        this.topNum.reject = creaty.exec3Count || 0;
      }
    },
    async contentType() {
      const response = await getOrderContentCode()
      if (response && response.code == this.successCode)
        this.contentTypeList = response.data || []
    },
    async getOrderGraphInfo() {
      if (!this.orderInfo) return
      const { orderCode: orderCodes, startDate, endDate } = this.orderInfo
      if (!orderCodes) return
      const dayParam = { orderCodes, startDate, endDate }
      const segParam = { orderCodes, startDate: this.pieDate, endDate: this.pieDate }
      const load = this.$loading()
      const response = this.curSwitchIdx == 0 ? await getOrderGraphDay(dayParam) : await getOrderGraphSegment(segParam)
      load.close()
      this.echartPieData = [] // 重置 清楚图标数据
      if (!response || response.code != 0) return

      if (response.data) {
        const result = response.data
        this.curSwitchIdx === 0 && (this.orderReport = result)
        this.echartPieData = this.curSwitchIdx === 0 ? result.orderFlowrateTimeList || [] : result
      }
    }
  }
}
</script>

<style lang="sass">
.pie-title
    .el-date-editor
        width: 165px
        cursor: pointer
        z-index: 1
        input
            border: none
            padding: 0
            color: #6296FF
            background: none
            padding-left: 70px
            padding-right: 32px
            cursor: pointer
        .el-input__prefix, .el-input__suffix
            display: none
</style>

<style lang="sass" scoped>
.home
    padding: 30px 20px 20px
    height: 100%
    .home-num
        line-height: 1
        img
            width: 16px
            height: 16px
            margin-top: -1px
            margin-right: 8px

        span
            &.big
                font-size: 16px
                color: #666
            &.red
                color: #FF3973
            &.blue
                color: #421EEF
            &.block
                display: inline-block
                padding: 0 20px
                border-right: 1px solid #E9E9E9
                &.no-r
                    border-right: none

    .home-fee
        height: 120px
        padding: 20px
        border-radius: 10px
        // margin-top: 20px
        // background: linear-gradient(135deg,rgba(216,202,154,0.5) 0%,rgba(196,171,130,0.5) 100%)
        background: #f5f5f5
        >img
            width: 80px
            height: 80px
            margin-right: 20px

        .center
            display: inline-block
            width: calc(100% - 281px)
            .each
                display: inline-block
                width: 33.333333%
                font-weight: 400
                height: 40px
                border-left: 1px solid #d4d4d4
                text-align: center
                font-size: 16px
                margin-top: 20px
                > span
                    position: relative
                    top: -5px
                div
                    font-size: 28px
                    font-weight: 800
                    .small
                        font-size: 24px

        .home-put
            padding-left: 20px
            height: 40px
            margin-top: 20px
            margin-right: 50px
            // border-left: 1px solid #fff
            .btn
                width: 190px
                height: 40px
                border-radius: 20px
                // background: #fff
                background: linear-gradient(315deg,rgba(255,132,109,1) 0%,rgba(255,57,115,1) 100%)
                color: #fff
                line-height: 40px
                font-weight: bold
                padding: 0 20px
                cursor: pointer
                img
                    float: right
                    width: 16px
                    height: 16px
                    margin-top: 12px
                    position: relative
                    left: 5px

.home-main
    margin-top: 30px
    height: calc(100% - 150px)
    .echart-main
        height: calc(100% - 31px)
        position: relative
        padding: 20px 20px 0
        border: 1px solid #e9e9e9
        position: relative
        .switch-ctn
            position: absolute
            right: 20px
            top: 20px
            width: 84px
            height: 30px
            text-align: center
            background: #F5F5F5
            border-radius: 30px
            padding: 4px 0
            z-index: 1
            .tab
                height: 22px
                line-height: 22px
                width: 50%
                color: #999
                font-size: 12px
                border-radius: 30px
                display: inline-block
                // float: left
                cursor: pointer
                &.cur
                    background: #FF3973
                    color: #fff
        .not-see
            position: absolute
            left: 0
            top: 0
            z-index: 1
            width: 100%
            height: 100%
            background: #f5f5f5
            font-size: 16px
            text-align: center
            padding-top: 180px
            line-height: 1.5
            span
                color: #999
                font-size: 14px

    .pie-title
        font-size: 18px
        font-weight: 600
        > span
            color: #6296FF
            position: relative
            margin-left: 20px
            display: inline-block
            line-height: 28px
            cursor: pointer
            font-weight: normal
            font-size: 14px
            span
                position: absolute
                z-index: 0
                top: 0
                display: inline-block
                &.l
                    left: 0
                    width: 70px
                &.r
                    right: 0
                    width: 32px
</style>
